import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'survey',
  initialState: {
    enrollment: null,
    salesForceObj: null,
    categoryBrandProductQuestionObject: null,
    survey: null,
    answeredCategoryBrandProductQuestionObject: null,
    theme: '',
    selectedCategoryBrandProductQuestionObject: null
  },
  reducers: {
    setEnrollment: (state, action) => {
      state.enrollment = action.payload
    },
    setSalesForceObj: (state, action) => {
      state.salesForceObj = action.payload
    },
    setCategoryBrandProductQuestionObject: (state, action) => {
      state.categoryBrandProductQuestionObject = action.payload
    },
    setAnsweredCategoryBrandProductQuestionObject: (state, action) => {
      state.answeredCategoryBrandProductQuestionObject = action.payload
    },
    setTheme: (state, action) => {
      state.theme = action.payload
    },
    setSelectedCategoryBrandProductQuestionObject: (state, action) => {
      state.selectedCategoryBrandProductQuestionObject = action.payload
    }
  }
})

export const {
  setEnrollment,
  setSalesForceObj,
  setCategoryBrandProductQuestionObject,
  setAnsweredCategoryBrandProductQuestionObject,
  setTheme,
  setSelectedCategoryBrandProductQuestionObject
} = slice.actions

export default slice.reducer
